import React from "react";

const Holiday = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          className="u_fill"
          d="M29.28 16.4H7.16V10c0-.42.17-.83.46-1.13.3-.3.7-.47 1.12-.47h1.58V10c0 .42.17.83.46 1.13.3.3.7.47 1.12.47.42 0 .82-.17 1.12-.47.29-.3.46-.71.46-1.13V8.4h9.48V10c0 .42.17.83.46 1.13.3.3.7.47 1.12.47.42 0 .82-.17 1.12-.47.3-.3.46-.71.46-1.13V8.4h1.58c.42 0 .82.17 1.12.47.3.3.46.71.46 1.13v6.4zm1.78-9.79A4.73 4.73 0 0027.7 5.2h-1.58V3.6c0-.42-.16-.83-.46-1.13-.3-.3-.7-.47-1.12-.47-.42 0-.82.17-1.11.47-.3.3-.47.71-.47 1.13v1.6h-9.48V3.6c0-.42-.17-.83-.46-1.13-.3-.3-.7-.47-1.12-.47-.42 0-.82.17-1.12.47-.29.3-.46.71-.46 1.13v1.6H8.74c-1.26 0-2.46.51-3.35 1.41C4.5 7.51 4 8.73 4 10v19.2c0 1.27.5 2.49 1.39 3.39.89.9 2.09 1.41 3.35 1.41H27.7c1.26 0 2.47-.51 3.36-1.41.88-.9 1.38-2.12 1.38-3.39V10c0-1.27-.5-2.49-1.38-3.39zM27 26.6l-7.16-2.27v4.82l2.69 1.5V32l-4.03-.9-4.03.9v-1.35l2.69-1.5v-4.82L10 26.6v-1.8l7.16-4.55v-4.9c0-.36.14-.7.39-.95.25-.26.59-.4.95-.4s.7.14.95.4c.25.25.39.59.39.95v4.9L27 24.8v1.8z"
          fill={fill}
      />
    </svg>
);

export default Holiday;
